// extracted by mini-css-extract-plugin
module.exports = {"emptyResult":"styles_emptyResult__jTg_m","emptyText":"styles_emptyText__h6g5_","crossIcon":"styles_crossIcon__457Jv"};